import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { DeleteWhiteLabelModal } from 'src/app/components/settings/delete-whitelabel/delete-whitelabel.modal';
import { EditWhiteLabelModal } from 'src/app/components/settings/edit-whitelabel/edit-whitelabel.modal';
import { IdsForSettingsService, WhiteLabelInfoModel } from 'src/app/components/settings/ids-for-settings.service';
import { SettingsService } from 'src/app/components/settings/settings.service';
import { IdentityWhitelabelApiClient } from 'src/app/services/api-clients/identity-whitelabel.api-client';
import { LoggingService } from 'src/app/services/logging.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-whiteLabelProvidersListItem',
  templateUrl: './whitelabelproviderslistitem.component.html'
})
export class WhiteLabelProvidersListItemComponent {

  constructor(private modalService: NgbModal, private router: Router,
    private idsForSettingsService: IdsForSettingsService,
    private route: ActivatedRoute, 
    private loggingService: LoggingService,
    private whitelabelproviderApiClient: IdentityWhitelabelApiClient, 
    private settingService: SettingsService,
    private toastService: ToastService,
    private translateService: TranslateService) {
      this.getTranslations();
      translateService.onLangChange.subscribe(() => {
        this.getTranslations();
      });
  }
  
  private _whiteLabelProvider!: any;
  whiteLabelProviderData!: any;
  whiteLabelProviders: any[] = [];
  translations = <any>{};
  @Input('whitelabelprovider') set whiteLabelProvider(val: any) {
    this._whiteLabelProvider = val;
    this.whitelabelproviderApiClient.getWhitelabel(val.whiteLabel.guid).subscribe({
      next: (whiteLabelProviderData: any) => {
        this.whiteLabelProviderData = whiteLabelProviderData;
      }
    });
  }
  get whitelabelprovider(): any {
    return this._whiteLabelProvider;
  }
  @Output('triggerAction') triggerAction = new EventEmitter();

  getTranslations() {
    this.translateService.get([
      'Toasts.UpdateWhiteLabelError',
      'Toasts.Error',
    ]).subscribe(translation => {
      this.translations.toastsUpdateWhiteLabelError = translation['Toasts.UpdateWhiteLabelError'];
      this.translations.error = translation['Toasts.Error'];

    });
  }

  deleteWhiteLabelProvider() {
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      windowClass: 'dialog-bg-white'
    };
    const modalRef = this.modalService.open(DeleteWhiteLabelModal, ngbModalOptions);
    modalRef.componentInstance.whitelabelproviderGuid = this.whitelabelprovider.whiteLabel.guid;
    modalRef.componentInstance.whitelabelproviderName = this.whitelabelprovider.whiteLabel.name;
    modalRef.componentInstance.organisationCount = this.whiteLabelProviderData.whiteLabel.organisations.length;
    modalRef.closed.subscribe({
      next: (deleteSuccesfull) => {
        if (deleteSuccesfull !== true) {
          return;
        }
        // on succesfull delete bubble/emit the refresh up
        this.triggerAction.emit({ action: 'deleteWhiteLabelProvider', id: this.whitelabelprovider.whiteLabel.guid });
      }
    });
  }

  openWhiteLabelProviderOverview() {
    this.idsForSettingsService.setSelectedWhitelabel(new WhiteLabelInfoModel(this.whitelabelprovider.whiteLabel.guid, this.whitelabelprovider.whiteLabel.name))
    this.router.navigate(['/settings', 'whitelabel', this.whitelabelprovider.whiteLabel.guid, 'overview'], { relativeTo: this.route })
      .catch(error => {
        this.loggingService.logException(error);
      });
  }

  private async getWhitelabelProviders() {
    let getOrganisations = await this.whitelabelproviderApiClient.getOrganisations(this.settingService.whiteLabelGuid);
    return await lastValueFrom(getOrganisations);
  }

  async editwhiteLabelProvider() {
    if (this.modalService.hasOpenModals()) return;
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      backdrop: 'static'
    };

    const modalRef = this.modalService.open(EditWhiteLabelModal, ngbModalOptions);
    modalRef.componentInstance.whiteLabelProvider = this.whiteLabelProviderData;
    modalRef.componentInstance.user = this.settingService.user;
    modalRef.componentInstance.updateWhiteLabelProvider.subscribe(async (whiteLabelProvider: any) => {
      await this.whitelabelproviderApiClient.updateWhiteLabelProvider(this.whitelabelprovider.whiteLabel.guid, whiteLabelProvider)
        .then(result => {
          lastValueFrom(result)
            .then((whiteLabelId: any) => {
              this.triggerAction.emit({ action: 'updateWhiteLabelProviders' });
              this.toastService.showSaved();
            })
            .catch((error) => {
              this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsUpdateWhiteLabelError + "");
            });
        })
        .catch((error) => this.loggingService.logException(error));

      modalRef.close();
      this.settingService.updateOrganisation(this.whiteLabelProviderData);
      modalRef.close();

    });
  }
}
